module.exports = __webpack_public_path__ + "static/media/space-two.b846713b.svg";